<sh-search #search id="search" [attr.label]="(businessPartnerMode ? 'autocomplete.search.placeholder.bp' : 'autocomplete.search.placeholder') | transloco" (input)="onInput($event)" (focusin)="resetIndex()"
  no-border style="width: 100%" [value]="searchWord" [error]="isError" [attr.error-message]="'autocomplete.search.errorMessage' | transloco"
  (clearsearch)="clearSearch()" (keydown)="onKeyDown($event)"
  [attr.aria-activedescendant]="activeIndex >= 0 ? 'result-' + activeIndex : null" aria-controls="resultsList"
  aria-haspopup="listbox" [attr.tabindex]="disabled ? -1 : 1" [disabled]="disabled"
[class.bp-disabled-autocomplete__search]="disabled" style="border-radius: 3px 3px 0 0 ;"></sh-search>

<sh-popover id="autocomplete-popover-1" #popover suppress-placement-warning="true" position="bottom" target="search" scroll-action="refit"
  overlay-target-distance="0" viewport-padding="0" [visible]="!disabled && resultsVisible" [style.width.px]="popoverwidth"
  sticky manual-controlled
  (overlay-closed)="closeOverlay()"
  style="max-height: 50vh; overflow-y: auto; overflow-x:hidden; z-index: 9999; border-radius: 0 0 3px 3px ;"
  [mobile]="false" [activeIndex]="activeIndex">

  <!-- Device Results -->
  @if (searchWord.length > 0 && results.deviceResults.length > 0) {
    <div>
      <div style="display: flex; justify-content: flex-start; align-items: center; gap: 8px; width: 100%">
        <sh-icon id="autocomplete-icon-laboratory-system" icon="laboratory-system" size="s"></sh-icon>
        <sh-text id="autocomplete-text-3" size="title-1" style="width: auto;">{{ 'autocomplete.results.deviceResults' | transloco }} ({{ results.deviceResults.length }})</sh-text>
      </div>
      <sh-divider id="autocomplete-divider-4"></sh-divider>
      <sh-list id="autocomplete-list-search-results" integrated flat condensed [attr.label]="'autocomplete.results.searchResults' | transloco">
        @for (item of results.deviceResults; track item['SERIAL_NUMBER'] + '-' + item['MATERIAL_NUMBER']; let i = $index) {
          <div
            style="display: flex; align-items: center; gap: 8px" tabindex="0" #resultsdom
            (keydown)="onKeyDownResults($event)" role="option" (keydown.enter)="setNewDevice(item)"
            [attr.aria-selected]="i === activeIndex">
            <sh-list-item id="autocomplete-list-item-6" class="custom-list" style="flex-grow: 1;" condensed [label]="item['SERIAL_NUMBER']"
              [info]="item['FUNCTIONAL_LOCATION']" (click)="setNewDevice(item)" divider="none" clickable
              [disabled]="item.Support === 'None' || item.Support === 'Unauthorized'">
            </sh-list-item>
            @if (item.Support === 'None') {
              <sh-icon icon="information" size="s" button [id]="'nosupport-'+i"
              style="margin-right: 8px;"></sh-icon>
            }
            <sh-tooltip id="autocomplete-tooltip-non-supported-device" [attr.label]="'autocomplete.tooltip.nonSupportedDevice' | transloco" [target]="'nosupport-'+i" [attr.title]="'autocomplete.tooltip.information' | transloco" placement="top"
            variation="short" style="max-width: 250px"></sh-tooltip>
            @if (item.Support === 'Unauthorized') {
              <sh-icon icon="lock" size="s" button [id]="'unat-'+i"
              style="margin-right: 8px;"></sh-icon>
            }
            <sh-tooltip id="autocomplete-tooltip-information" [target]="'unat-'+i" [attr.title]="'autocomplete.tooltip.information' | transloco" placement="top" variation="short"
              style="max-width: 250px">
              <p class="body-100">{{ 'autocomplete.tooltip.accessRestriction' | transloco }} <b><a
                href="https://healthineers.sharepoint.com/teams/ldfleetanalytics/SitePages/LS-Service-Copilot.aspx?xsdata=MDV8MDJ8fDk3YWU0NzdlZDAxYjRhNDUwODQxMDhkZGY5YjJkNjA5fDVkYmYxYWRkMjAyYTRiOGQ4MTViYmYwZmIwMjRlMDMzfDB8MHw2Mzg5NDEyNjg2NDY4OTI2NTJ8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKRFFTSTZJbFJsWVcxelgwRlVVRk5sY25acFkyVmZVMUJQVEU5R0lpd2lWaUk2SWpBdU1DNHdNREF3SWl3aVVDSTZJbGRwYmpNeUlpd2lRVTRpT2lKUGRHaGxjaUlzSWxkVUlqb3hNWDA9fDF8TDJOb1lYUnpMekU1T20xbFpYUnBibWRmVG5wRmVWbDZUVFJPVjFWMFdtcFZlRTVETURCWlYwbDNURmRGZVU5SFZYUk5NbFp0V2xkWk1VNVVTbWxOYW1Sc1FIUm9jbVZoWkM1Mk1pOXRaWE56WVdkbGN5OHhOelU0TlRNd01ESTNPRE14fDNlNzNlYjY1NTVkZjQzNTU5M2ViMDhkZGY5YjJkNjA4fGEzMWNlNTJmYzRlYzQ1MDU4NGRhMTEwZmZhY2U5Mzgx&sdata=NFllc3g0ekdrZHliWDNPYnhpQndlbGl1L1BQWkQ0eWRVbmJmVnVwTGlNZz0%3D&ovuser=5dbf1add-202a-4b8d-815b-bf0fb024e033%2Csteffen.klima%40siemens-healthineers.com&OR=Teams-HL&CT=1758536856452&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI0OS8yNTA4MjgxNzkxMiIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D#web-application-axis"
              target="_blank">{{ 'autocomplete.tooltip.accessRestrictionLink' | transloco }}</a></b></p>
            </sh-tooltip>
          </div>
        }
      </sh-list>
    </div>
  }

  <!-- Site Results -->
  @if (searchWord.length > 0 && results.siteResults.length > 0) {
    <div style="width: 100%">
      <div style="display: flex; justify-content: flex-start; align-items: center; gap: 8px; width: 100%">
        <sh-icon id="autocomplete-icon-manufacturer" icon="manufacturer" size="s"></sh-icon>
        <sh-text id="autocomplete-text-10" size="title-1" style="width: auto;">{{ 'autocomplete.results.siteResults' | transloco }} ({{ results.siteResults.length }})</sh-text>
      </div>
      <sh-divider id="autocomplete-divider-11"></sh-divider>
      <sh-list id="autocomplete-list-search-results" integrated flat condensed [attr.label]="'autocomplete.results.searchResults' | transloco">
        @for (item of results.siteResults; track item.id; let i = $index) {
          <div (keydown.enter)="setNewSite(item.id)"
            style="display: flex; align-items: center; gap: 8px" tabindex="0" #resultsdom
            (keydown)="onKeyDownResults($event)" role="option" [attr.aria-selected]="i === activeIndex">
            <sh-list-item id="autocomplete-list-item-13" [style.width.px]="popoverwidth - (item.support !== 'Full' ? 64 : 36)" class="custom-list"
              style="flex-grow: 1;" condensed [label]="item.location_name" divider="none" clickable (click)="setNewSite(item.id)"
              [disabled]="item.support === 'None' || item.support === 'Unauthorized'">
              <div style="display: flex; flex-direction: column;"
                [style.width.px]="popoverwidth - (item.support !== 'Full' ? 64 : 36)">
                <sh-text id="autocomplete-text-14" size="body-2" color="secondary"
                  style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{
                item.address }} </sh-text>
                <sh-text id="autocomplete-text-15" size="body-2" color="secondary"
                  style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;">{{
                item.city + ' ' + item.zip }} </sh-text>
                <sh-text id="autocomplete-text-16" size="body-2" color="secondary">{{
                  item.country }}
                  <span [class]="'fi fis fi-'+item.country.toLowerCase() "></span>
                </sh-text>
              </div>
            </sh-list-item>
            @if (item.support === 'None') {
              <sh-icon icon="information" size="s" button
              [id]="'nosupport-site-'+i" style="padding-right: 16px;"></sh-icon>
            }
            <sh-tooltip id="autocomplete-tooltip-non-supported-site" [attr.label]="'autocomplete.tooltip.nonSupportedSite' | transloco" [target]="'nosupport-site-'+i" [attr.title]="'autocomplete.tooltip.information' | transloco"
            placement="top" variation="short" style="max-width: 250px"></sh-tooltip>
            @if (item.support === 'Unauthorized') {
              <sh-icon icon="lock" size="s" button [id]="'unat-'+i"
              style="margin-right: 8px;"></sh-icon>
            }
            <sh-tooltip id="autocomplete-tooltip-information" [target]="'unat-'+i" [attr.title]="'autocomplete.tooltip.information' | transloco" placement="top" variation="short"
              style="max-width: 250px">
              <p class="body-100">{{ 'autocomplete.tooltip.accessRestriction' | transloco }} <b><a
                href="https://healthineers.sharepoint.com/teams/ldfleetanalytics/SitePages/LS-Service-Copilot.aspx?xsdata=MDV8MDJ8fDk3YWU0NzdlZDAxYjRhNDUwODQxMDhkZGY5YjJkNjA5fDVkYmYxYWRkMjAyYTRiOGQ4MTViYmYwZmIwMjRlMDMzfDB8MHw2Mzg5NDEyNjg2NDY4OTI2NTJ8VW5rbm93bnxWR1ZoYlhOVFpXTjFjbWwwZVZObGNuWnBZMlY4ZXlKRFFTSTZJbFJsWVcxelgwRlVVRk5sY25acFkyVmZVMUJQVEU5R0lpd2lWaUk2SWpBdU1DNHdNREF3SWl3aVVDSTZJbGRwYmpNeUlpd2lRVTRpT2lKUGRHaGxjaUlzSWxkVUlqb3hNWDA9fDF8TDJOb1lYUnpMekU1T20xbFpYUnBibWRmVG5wRmVWbDZUVFJPVjFWMFdtcFZlRTVETURCWlYwbDNURmRGZVU5SFZYUk5NbFp0V2xkWk1VNVVTbWxOYW1Sc1FIUm9jbVZoWkM1Mk1pOXRaWE56WVdkbGN5OHhOelU0TlRNd01ESTNPRE14fDNlNzNlYjY1NTVkZjQzNTU5M2ViMDhkZGY5YjJkNjA4fGEzMWNlNTJmYzRlYzQ1MDU4NGRhMTEwZmZhY2U5Mzgx&sdata=NFllc3g0ekdrZHliWDNPYnhpQndlbGl1L1BQWkQ0eWRVbmJmVnVwTGlNZz0%3D&ovuser=5dbf1add-202a-4b8d-815b-bf0fb024e033%2Csteffen.klima%40siemens-healthineers.com&OR=Teams-HL&CT=1758536856452&clickparams=eyJBcHBOYW1lIjoiVGVhbXMtRGVza3RvcCIsIkFwcFZlcnNpb24iOiI0OS8yNTA4MjgxNzkxMiIsIkhhc0ZlZGVyYXRlZFVzZXIiOmZhbHNlfQ%3D%3D#web-application-axis"
              target="_blank">{{ 'autocomplete.tooltip.accessRestrictionLink' | transloco }}</a></b></p>
            </sh-tooltip>
          </div>
        }
      </sh-list>
    </div>
  }

  <!-- Show either Last Search or Start Typing -->
  @if (searchWord.length === 0 && (results.deviceResults.length === 0 && results.siteResults.length === 0)) {
    <div>
      @if (recentsearches.length === 0 && recentsearchessites.length === 0) {
        <div id="placeholder">
          <sh-text id="autocomplete-text-19">{{ 'autocomplete.placeholder.startTyping' | transloco }}</sh-text>
        </div>
      }
      @if (recentsearches.length > 0 || recentsearchessites.length > 0) {
        <div id="recents">
          <div style="display: flex; justify-content: flex-start; align-items: center; gap: 8px; width: 100%">
            <sh-icon id="autocomplete-icon-studies-in-time" icon="studies-in-time" size="s"></sh-icon>
            <sh-text id="autocomplete-text-21" size="title-1" style="width: auto;">{{ 'autocomplete.placeholder.recentSearches' | transloco }}</sh-text>
          </div>
          <sh-divider id="autocomplete-divider-22"></sh-divider>
          <div style="display: flex; gap: 6px; flex-wrap: wrap;">
            @for (recent of recentsearches; track recent['SERIAL_NUMBER'] + '-' + recent['MATERIAL_NUMBER']) {
              <div tabindex="0" (keydown.enter)="setNewDevice(recent)"
                [ngClass]="{'custom-tag': true, 'disabled': recent['Support'] === 'Unauthorized' || recent['Support'] === 'None'}">
                <span (click)="setNewDevice(recent)"
                [ngClass]="recent['Support'] === 'Unauthorized' || recent['Support'] === 'None' ? 'disabled': ''">{{recent['SERIAL_NUMBER']}}</span>
                @if (checkIfDupSerial(recent['SERIAL_NUMBER'])) {
                  <span>{{ recent['MATERIAL_NUMBER'] }}</span>
                }
                <sh-icon id="autocomplete-icon-cancel" icon="cancel" size="xs"
                  [disabled]="recent['Support'] === 'Unauthorized' || recent['Support'] === 'None'"
                (click)="removeFromRecents($event,recent)"></sh-icon>
              </div>
            }
            @for (recent of recentsearchessites; track recent.Id) {
              <div tabindex="0" (keydown.enter)="setNewSite(recent.Id)"
                [ngClass]="{'custom-tag': true, 'disabled': recent['Support'] === 'Unauthorized' || recent['Support'] === 'None'}">
                <span (click)="setNewSite(recent.Id)"
                [ngClass]="recent['Support'] === 'Unauthorized' || recent['Support'] === 'None' ? 'disabled': ''">{{recent['Name']}}</span>
                <sh-icon id="autocomplete-icon-cancel" icon="cancel" size="xs"
                  [disabled]="recent['Support'] === 'Unauthorized' || recent['Support'] === 'None'"
                (click)="removeFromRecentsSites($event,recent)"></sh-icon>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }


  <!-- Display if not enough words in query but more than one word -->
  @if ((searchWord.length > 0 && searchWord.length < 3 )) {
    <div
      >
      <sh-text id="autocomplete-text-25">{{ 'autocomplete.placeholder.typeMore' | transloco }}</sh-text>
    </div>
  }

  <!-- Display content if there is a result -->
  @if (isEmpty) {
    <div>
      <sh-text id="autocomplete-text-26">{{ 'autocomplete.placeholder.noResults' | transloco }}</sh-text>
    </div>
  }

  @if (isLoading) {
    <div>
      <sh-spinner id="autocomplete-spinner-27" size="s"></sh-spinner>
    </div>
  }

  <!-- Display content if there is a result -->
  @if (isError) {
    <div>
      <sh-text id="autocomplete-text-28" style="color: #E7001D">{{ 'autocomplete.error.unavailable' | transloco }}</sh-text>
    </div>
  }

  @if (!isError && !isLoading && results.deviceResults.length === 0 && results.siteResults.length === 0 && searchWord.length >=3 && !isEmpty) {
    <div>
      <sh-spinner id="autocomplete-spinner-29" size="s"></sh-spinner>
    </div>
  }

</sh-popover>